export const APPLICANT_USER_TYPE = 1